import { render } from "./TopNavigationAdditionalButtons.vue?vue&type=template&id=54d18b7a"
import script from "./TopNavigationAdditionalButtons.vue?vue&type=script&lang=js"
export * from "./TopNavigationAdditionalButtons.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__